import Breadcrumb from "../../../Breadcrumb";

const History = () => {
  return (
   <>

   {/* Breadcrumb */}
   <Breadcrumb />
    
   This is business History page 
   </>
  );
};

export default History;